export interface CaseStudy {
  slug: string
  title: string
  client: string
  industry: string
  year: string
  description: string
  highlights: string[]
  stack: string[]
  url?: string
}

export const cases: CaseStudy[] = [
  {
    slug: 'resolv',
    title: 'Resolv — governança digital e expansão empresarial',
    client: 'Resolv',
    industry: 'Consultoria / Estratégia',
    year: '2024–2026',
    description:
      'Parceria contínua de engenharia que materializa o Método Resolv 3D em produtos digitais. Atuamos como braço técnico de uma consultoria de governança e expansão empresarial entre Espanha, Galicia e Brasil — diagnóstico estratégico, pipelines de dados, modelos de IA e camadas de gestão de risco.',
    highlights: [
      'Plataforma multi-idioma (ES · PT · Galego) com SEO técnico e compliance LGPD/GDPR',
      'Pipelines de dados e IA aplicados ao diagnóstico estratégico de empresas',
      'Arquitetura cloud-native em AWS (S3 + CloudFront) com Consent Mode v2',
    ],
    stack: ['AWS', 'Node.js', 'React + Vite', 'Python', 'IA / ML'],
    url: 'https://resolv.es/',
  },
  {
    slug: 'visualitics',
    title: 'Visualitics — analytics contextual pra e-commerce',
    client: 'Visualitics',
    industry: 'E-commerce / SaaS',
    year: '2025–2026',
    description:
      'Plataforma SaaS de analytics para e-commerce que consolida dados de Mercado Livre, Amazon, Shopee e GA4 e mostra margem real, ROI e inteligência de concorrência direto na página do produto — eliminando o vai-e-volta entre 6 ferramentas diferentes.',
    highlights: [
      'Integrações com marketplaces (Mercado Livre, Amazon, Shopee) e GA4',
      'Inteligência contextual no momento da decisão, dentro do PDP',
      'Stack moderna React + Vite hospedada em GCP com CSP estrito',
    ],
    stack: ['React + Vite', 'Tailwind', 'Radix UI', 'GCP', 'nginx'],
    url: 'https://visualitycs.com.br/',
  },
  {
    slug: 'multiapp-central-multimidia',
    title: 'Multiapp — apps e lojas para Central Multimídia automotiva',
    client: 'Multiapp',
    industry: 'Automotivo / Mobile',
    year: '2024–2026',
    description:
      'Arquitetura e desenvolvimento da plataforma Multiapp, ecossistema de aplicativos e lojas embarcados em Centrais Multimídia automotivas. Integração ponta a ponta entre app mobile, painel admin e dispositivos veiculares.',
    highlights: [
      'Apps embarcados em Central Multimídia rodando em frota real',
      'Backend .NET 8 multi-tenant com PostgreSQL',
      'CI/CD com snapshot pré-deploy e auto-rollback',
    ],
    stack: ['.NET', 'React Native', 'SQL Server', 'PostgreSQL'],
  },
  {
    slug: 'multiapp-iot',
    title: 'Multiapp IoT — rastreamento veicular e gestão de frotas',
    client: 'Multiapp',
    industry: 'Automotivo / IoT',
    year: '2023–2025',
    description:
      'Arquitetura e desenvolvimento de soluções IoT pro setor automotivo: implantação de rastreador veicular e aplicativo nativo de gestão de frotas, integrado com dispositivos embarcados em tempo real.',
    highlights: [
      'Rastreamento em tempo real com baixíssima latência',
      'App nativo Android + React Native multi-plataforma',
      'Backend pronto pra escalar com a frota',
    ],
    stack: ['Java', 'Android', 'React Native'],
  },
  {
    slug: 'netbrokers-lm-mobilidade',
    title: 'NETBROKERS | LM Mobilidade — precificação e automação automotiva',
    client: 'NETBROKERS / LM Mobilidade',
    industry: 'Automotivo / Mobilidade',
    year: '2023–2024',
    description:
      'Arquitetura e desenvolvimento de projetos pra área automotiva: sistema de precificação, integrações entre sistemas e automatização de processos comerciais críticos.',
    highlights: [
      'Engine de precificação integrada com Salesforce',
      'Automatização de processos comerciais ponta a ponta',
      'Integrações .NET ↔ Salesforce ↔ SQL Server',
    ],
    stack: ['.NET', 'React', 'Salesforce', 'SQL Server'],
  },
  {
    slug: 'h3-bringoz',
    title: 'H3 Solutions | Bringoz — SaaS de logística de última milha',
    client: 'H3 Solutions',
    industry: 'Logística / SaaS',
    year: '2023',
    description:
      'Plataforma SaaS de integração de pedidos e roteirização com a Bringoz — solução israelense de logística de entrega em tempo real que oferece infraestrutura escalável de ponta a ponta.',
    highlights: [
      'Integração com plataforma global Bringoz',
      'Roteirização em tempo real ponta a ponta',
      'Infraestrutura escalável com PostgreSQL',
    ],
    stack: ['C#', 'React', 'PostgreSQL'],
  },
  {
    slug: 'risksquad',
    title: 'RiskSquad — plataforma SaaS de segurança de aplicações',
    client: 'RiskSquad',
    industry: 'Cybersecurity / SaaS',
    year: '2023–2024',
    description:
      'Plataforma SaaS de gestão de segurança de aplicações, integrando pentesting, programas de bug bounty e security champions pra centralizar vulnerabilidades e otimizar priorização de riscos.',
    highlights: [
      'Centralização de vulnerabilidades em painel único',
      'Integração com programas de bug bounty',
      'Priorização de riscos data-driven',
    ],
    stack: ['PHP', 'React'],
    url: 'https://risksquad.io/',
  },
  {
    slug: 'entercom-quest',
    title: 'Entercom | Quest — plataforma educacional de provas automatizadas',
    client: 'Entercom',
    industry: 'Educação / SaaS',
    year: '2022–2023',
    description:
      'Desenvolvimento de aplicação para o setor educacional, responsável por gerenciamento de banco de questões e elaboração automatizada de provas pra grandes redes de ensino.',
    highlights: [
      'Banco de questões com elaboração automatizada de provas',
      'Frontend Angular 14 + backend .NETCore',
      'Adoção em escala em redes de ensino',
    ],
    stack: ['Angular 14', '.NET Core 3.1', 'SQL Server'],
  },
  {
    slug: 'entercom-einstein',
    title: 'Entercom | Acervo Einstein — portal de acervo e notícias',
    client: 'Hospital Israelita Albert Einstein',
    industry: 'Saúde / Mídia',
    year: '2022',
    description:
      'Modernização do portal de acervo e notícias do Hospital Einstein, com otimizações de SEO pra melhorar alcance orgânico e controle de acesso pra diferentes perfis de usuário.',
    highlights: [
      'SEO técnico que aumentou alcance orgânico',
      'ACL multi-perfil de usuário',
      'Frontend Vue + backend C#',
    ],
    stack: ['Vue', 'C#', 'jQuery'],
  },
  {
    slug: 'entercom-cubo-itau',
    title: 'Entercom | Cubo Itaú — refinamento de arquitetura HubSpot',
    client: 'Cubo Itaú',
    industry: 'Inovação / CRM',
    year: '2022',
    description:
      'Análise e refinamento da arquitetura do HubSpot no Cubo Itaú, com foco em implementação de melhorias de segurança e controle de acesso.',
    highlights: [
      'Hardening de segurança no HubSpot',
      'Redesenho de controle de acesso',
      'Auditoria e melhorias da arquitetura existente',
    ],
    stack: ['HubSpot'],
  },
  {
    slug: 'netbrokers-besni-infobip',
    title: 'NETBROKERS | Besni Infobip — disparo de SMS em massa com BI',
    client: 'Besni',
    industry: 'Varejo / Marketing',
    year: '2023',
    description:
      'Integração e disparo de SMS em massa pra Besni via Infobip, com interface pra upload de batches, disparos recorrentes e BI dedicado pra análise de performance das campanhas.',
    highlights: [
      'Upload de batches e disparos recorrentes',
      'BI nativo pra análise de campanhas',
      'Integração robusta com gateway Infobip',
    ],
    stack: ['Blazor', 'C#', 'SQL Server'],
  },
  {
    slug: 'entercom-parcell',
    title: 'Entercom | Parcell — sustentação de e-commerce e ERP B2B',
    client: 'Parcell',
    industry: 'E-commerce / B2B',
    year: '2021–2022',
    description:
      'Sustentação de e-commerce e ERP de uma distribuidora de peças de celular e tablets focada em B2B, com modernização gradual de stack e melhorias contínuas de UX.',
    highlights: [
      'Sustentação contínua de ERP B2B em produção',
      'E-commerce integrado ao ERP',
      'Stack AngularJS + .NETCore 3.1',
    ],
    stack: ['AngularJS', '.NET Core 3.1', 'SQL Server'],
  },
  {
    slug: 'wholefestival',
    title: 'Whole Festival — site oficial e venda de ingressos',
    client: 'Whole Festival',
    industry: 'Eventos / E-commerce',
    year: '2022',
    description:
      'Página oficial do Whole Festival com desenvolvimento e integração de venda de ingressos, transporte camping e loja de merchandise integrada.',
    highlights: [
      'Venda de ingressos online integrada',
      'Loja de merchandise + transporte/camping',
      'Site de alta visibilidade no calendário cultural',
    ],
    stack: ['WordPress', 'Elementor', 'PHP'],
    url: 'https://wholefestival.com/',
  },
  {
    slug: 'cannabis-empregos',
    title: 'Cannabis Empregos — plataforma de vagas no ramo canábico',
    client: 'Cannabis Empregos',
    industry: 'RH / Healthcare',
    year: '2022',
    description:
      'Plataforma de vagas e empregos no ramo canábico medicinal e empresarial brasileiro, com atualização e migração de temas em WordPress, migração de banco e análise de performance.',
    highlights: [
      'Migração WordPress + tema com zero downtime',
      'Migração de banco com análise de performance',
      'Plataforma de vagas em nicho regulado',
    ],
    stack: ['PHP', 'WordPress', 'MySQL', 'PostgreSQL'],
  },
  {
    slug: 'looptmize',
    title: 'Looptmize — sustentação de webportal e consultoria de infra',
    client: 'Looptmize',
    industry: 'SaaS / Infraestrutura',
    year: '2021',
    description:
      'Sustentação e redesign de webportal utilizando WordPress, somada à consultoria em infraestrutura pra deixar o stack mais resiliente e barato.',
    highlights: [
      'Redesign do webportal WordPress',
      'Consultoria de infra reduzindo custo',
      'Sustentação contínua com SLA acordado',
    ],
    stack: ['WordPress', 'PHP'],
  },
  {
    slug: 'i3-vps-infra',
    title: 'Plataforma de observabilidade self-hosted (interno)',
    client: 'i3 Solutions',
    industry: 'DevOps / Platform',
    year: '2026',
    description:
      'Stack completa de observabilidade rodando em VPS único: Prometheus, Loki, Tempo, Grafana, Glitchtip, Uptime-Kuma e Plausible. Mesma plataforma é reaproveitada pra cada cliente que prefere self-hosting.',
    highlights: [
      'Observabilidade end-to-end com R$ 0 de licença',
      'CI/CD com snapshot pré-deploy + auto-rollback',
      'Bot Discord interativo pra operações',
    ],
    stack: ['Docker Compose', 'Prometheus', 'Grafana', 'Tempo', 'Loki', 'nginx', 'GitHub Actions'],
  },
]
